'use client';

import { useEffect } from 'react';
import { Link } from '@pie/amber';
import { processError } from '@/lib/processError';
import { Footer } from '@/components/Footer';
import { PageContainer } from '@/components/Page/PageContainer';
import { PageError } from '@/components/Page/PageError';
import { StackedLayout } from '@/components/StackedLayout';
import { TEST_ERROR_CAUSE } from '@/test-utils/testErrorCause';

export default function GlobalErrorPage({
  error,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    if (error.cause !== TEST_ERROR_CAUSE) {
      processError(error);
    }
  }, [error]);

  return (
    <html lang="en">
      <body>
        <StackedLayout footer={<Footer />}>
          <PageContainer>
            <PageError
              heading="Something Went Wrong"
              helpText={
                <>
                  Try again later, or contact support at{' '}
                  <Link href="mailto:service@pieinsurance.com">service@pieinsurance.com</Link>.
                </>
              }
            />
          </PageContainer>
        </StackedLayout>
      </body>
    </html>
  );
}
